import React, { useContext } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ScoreContext } from "../CourseScoreProvider/context";
import { useHistory } from "react-router-dom";

interface NavBarProps {
    tab?: string;
    courseName: string;
}

export default function NavBar({ tab, courseName }: NavBarProps) {
    const { courseNo, courseSeq, weekTimeId } = useContext(ScoreContext);
    const history = useHistory();

    const onChange = (tab: string) => {
        history.replace(
            `/course/score/${tab}/${courseNo}/${courseSeq}/${weekTimeId}?courseName=${courseName}`
        );
    };

    return (
        <div className={style.root}>
            <div className={style.links}>
                <div
                    className={classNames(style.link, {
                        [style.current]: tab === "detail"
                    })}
                    onClick={() => onChange("detail")}>
                    成绩单
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: tab === "rules"
                    })}
                    onClick={() => onChange("rules")}>
                    成绩规则
                </div>
            </div>
        </div>
    );
}
